export default "__VITE_ASSET__Cm0N9E7s__"